import { useState, ReactNode } from "react";
import { dropDown, edit, trash } from "../asset";

export type SectionType = {
  id: number;
  name: string;
};

type ExpandableSectionProps = {
  section: SectionType;
  onEdit?: (id: number) => void;
  onDelete?: (id: number) => void;
  isFirst?: boolean;
  children?: ReactNode;
};

export default function ExpandableSection({
  section,
  onEdit,
  onDelete,
  isFirst = false,
  children,
}: ExpandableSectionProps) {
  const [open, setOpen] = useState(isFirst);

  return (
    <div>
      <div
        className="flex justify-between bg-[#F8F8F8] rounded-lg p-4 px-5 items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <h4 className="font-semibold text-sm text-neutral-400">{section.name}</h4>

        <div className="flex gap-5 items-center">
          <div className="flex gap-4">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onEdit(section.id);
              }}
            >
              <img onClick={() => setOpen(!open)} src={edit} alt="" className="w-4 h-4" />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete(section.id);
              }}
            >
              <img src={trash} alt="" className="w-4 h-4" />
            </button>
          </div>
          <img
            src={dropDown}
            alt=""
            className={`${open ? "rotate-180" : ""} w-4 h-4 transition`}
          />
        </div>
      </div>

      {open && <div className="mt-4">{children}</div>}
    </div>
  );
}
